exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".month-alert[data-v-74790fac] {\n  width: 100%;\n  background-color: white;\n  box-shadow: 2px 2px 2px 2px #8f8f8f;\n}\n.alert-1[data-v-74790fac] {\n  border-left: solid 5px #dc3545;\n}\n.alert-2[data-v-74790fac] {\n  border-left: solid 5px #ffc107;\n}\n.alert-3[data-v-74790fac] {\n  border-left: solid 5px #007bff;\n}\n.alert-4[data-v-74790fac] {\n  border-left: solid 5px #fd7e14;\n}\n.alert-5[data-v-74790fac] {\n  border-left: solid 5px #28a745;\n}", ""]);

// exports
